import React from 'react'
import ReactOnRails from "react-on-rails/client";

import SearchForm from 'frontend/SearchBox/SearchForm'
import LanguageSelect from 'frontend/Navigation/LanguageSelect'
import PopularLocations from 'frontend/Navigation/PopularLocations'
import Cookies from 'frontend/Navigation/Cookies'
import SeoCarClasses from 'frontend/Navigation/SeoCarClasses'
import SeoProviderReviews from 'frontend/Navigation/SeoProviderReviews'
import MobileMenu from 'frontend/Navigation/MobileMenu'
import ReviewsCarousel from 'frontend/Navigation/ReviewsCarousel'
import StaticReviews from 'frontend/Navigation/StaticReviews'
import SeoFaq from 'frontend/Navigation/SeoFaq'
import SeoOffer from 'frontend/Navigation/SeoOffer'
import SeoSearchModal from 'frontend/Navigation/SeoSearchModal'

ReactOnRails.register({SearchForm, LanguageSelect, PopularLocations, Cookies,
    SeoCarClasses, SeoProviderReviews, MobileMenu, ReviewsCarousel, StaticReviews, SeoFaq, SeoOffer, SeoSearchModal})